import { isAllOf } from "@reduxjs/toolkit";
import { authJsonEdit, authJsonGet, authJsonPost, authPostEmpty, get, getAuth, getSavedUser, getUrl, pubGet } from "functions/BaseAxios";
import { findTripDetailJQL, GuideTripList } from "functions/JQL/ListingJQL";
import { FC } from "react";
import { LOGIN_FALSE } from "../user/action";
export const PARTNER_OPEN_TRIP_ADD = 'PARTNER_OPEN_TRIP_ADD';
export const GET_SERVICES = 'GET_SERVICES';
export const SUBMITING_OPEN_TRIP = 'GET_SERVICES';
export const GUIDE_OPEN_TRIP_LIST = 'GUIDE_OPEN_TRIP_LIST';
export const GUIDE_PRIVATE_TRIP_LIST = 'GUIDE_PRIVATE_TRIP_LIST';
export const DETAIL_GUIDE_TRIP = 'DETAIL_GUIDE_TRIP';
export const PRIVATE_ADD_MODE = 'PRIVATE_ADD_MODE';
export const EDIT_MODE = 'EDIT_MODE';
export const ADD_MODE = 'ADD_MODE';
export const SEARCH_TRIPS = 'SEARCH_TRIPS';
export const DETAIL_TRIP = 'DETAIL_TRIP';
export const OTHERS_DETAIL_TRIP = 'OTHERS_DETAIL_TRIP';
export const LISTING_TRIP_ID = 'LISTING_TRIP_ID';
export const DELETE_SERVICE = 'DELETE_SERVICE';

let newProduct: any = {};
export function detailTrip(id: string, creds: any) {
    return async (dispatch: DispatchGeneral) => {
        let data;
        if (creds === LOGIN_FALSE) {
            data = await pubGet(`trip/${id}?page=1`);
        } else {
            data = await pubGet(`trip/${id}`);
        }

        dispatch({
            type: DETAIL_TRIP,
            payload:
                data.code === 200
                    ? data.payload.data.detail
                    : [],
        });
        dispatch({
            type: OTHERS_DETAIL_TRIP,
            payload:
                data.code === 200
                    ? data.payload.data.others
                    : [],
        });
    };
}

export function detailTripId(slug: any) {
    return async (dispatch: DispatchGeneral) => {
        let data = await pubGet(`trips-by-slug/${slug}`);
        updateIdTrip(false);
        dispatch({
            type: LISTING_TRIP_ID,
            payload:
                data.code === 200
                    ? data.payload.data
                    : 0,
        });
    };
}

let idTrip = true;

export function updateIdTrip(id: boolean) {
    idTrip = id
}

export function getIdiTrip() {
    return idTrip;
}

export function resetSearchTrips() {
    return async (dispatch: DispatchGeneral) => {
        dispatch({
            type: SEARCH_TRIPS,
            payload: null,
        });
    };
}
export function searchTrips(keyword: string, creds: any, openTrip?: any, code?: any, page?: any) {
    return async (dispatch: DispatchGeneral) => {
        let data;
        const openTripParam = (openTrip !== null && openTrip !== undefined && openTrip !== '' && openTrip !== 'null') ? `&openTrip=${openTrip}` : '';
        const countryParam = (code !== null && code !== undefined && code !== '' && code !== 'null') ? `&country=${code}` : '';

        const isLoggedIn = creds && creds !== LOGIN_FALSE && creds?.token;

        if (isLoggedIn) {
            data = await getAuth(`auth/search-trip/${keyword}?page=${page ?? 1}${openTripParam}${countryParam}`);
        } else {
            data = await pubGet(`search-trip/${keyword}?page=${page ?? 1}${openTripParam}${countryParam}`);
        }

        const isSuccess = data && data.code == 200 && data.payload;

        dispatch({
            type: SEARCH_TRIPS,
            payload: isSuccess
                ? {
                    keyword,
                    data: Array.isArray(data.payload.data) ? data.payload.data : [],
                    page: page ?? 1,
                    last: data.payload.last ?? false
                }
                : {
                    keyword,
                    data: [],
                    page: page ?? 1,
                    last: true
                },
        });
    };
}

export function openTripCheck(id: any) {
    return async (dispatch: DispatchGeneral) => {
        var creds = await getSavedUser();
        if (!creds?.user?.id) return;
        var data = await authJsonGet(
            findTripDetailJQL({
                where: {
                    product_user: {
                        equalTo: creds.user.id
                    },
                    product_isOpenTrip: {
                        equalTo: true
                    },
                    product_id: {
                        equalTo: id
                    }
                },
            }));

        if (data.code === 200 && (data.payload.product).length > 0) {
            newProduct = data.payload.product[0];
            // if (newProduct.totalPrice) {
            //     newProduct.totalPrice = (parseFloat(newProduct.totalPrice) - parseFloat(newProduct.feeAmount)).toString();
            // }
            newProduct.productService.map((service: any, key: any) => {
                let totalPrice = parseFloat(service.price);
                let fee = parseFloat(service.feeAmount);
                if (fee) {
                    let price = totalPrice - fee;
                    newProduct.productService[key].price = price.toString();
                }

            })
            newProduct['productImages'] = newProduct.file;

        }
        dispatch({
            type: PRIVATE_ADD_MODE,
            payload: newProduct,
        });
    };
}


export function privateTripCheck(country: any) {
    return async (dispatch: DispatchGeneral) => {
        var creds = await getSavedUser();
        if (!creds?.user?.id) return;
        var data = await authJsonGet(
            findTripDetailJQL({
                where: {
                    product_user: {
                        equalTo: creds.user.id
                    },
                    product_isOpenTrip: {
                        equalTo: false
                    },
                    country_id: {
                        equalTo: country
                    },
                    product_state: {
                        notEqualTo: 'deleted'
                    }
                },
            }));
        if (data.code === 200 && (data.payload.product).length > 0) {
            newProduct = data.payload.product[0];
            // if (newProduct.totalPrice) {
            //     newProduct.totalPrice = (parseFloat(newProduct.totalPrice) - parseFloat(newProduct.feeAmount)).toString();
            // }
            // if (newProduct.addSlotPrice > 0) {
            //     newProduct.addSlotPrice = (parseFloat(newProduct.addSlotPrice) - (parseFloat(newProduct.addPriceFeeAmount))).toString();
            // }

            // newProduct.productService.map((service: any, key: any) => {
            //     let totalPrice = parseFloat(service.price);
            //     let fee = parseFloat(service.feeAmount);
            //     if (fee) {
            //         let price = totalPrice - fee;
            //         newProduct.productService[key].price = price.toString();
            //     }

            // })
            newProduct['productImages'] = newProduct.file;
        }
        dispatch({
            type: PRIVATE_ADD_MODE,
            payload: newProduct,
        });
    };
}
export function getGuideOpenTrip(page = 1, limit = 7) {
    return async (dispatch: DispatchGeneral) => {
        var creds = await getSavedUser();
        if (!creds?.user?.id) return;
        var data = await authJsonGet(GuideTripList(1, 7, creds.user.id));
        dispatch({
            type: GUIDE_OPEN_TRIP_LIST,
            payload: data.code === 200 ? data.payload.product : [],
        });
    };
}

export function getGuidePrivateTrip(page = 1, limit = 7) {
    return async (dispatch: DispatchGeneral) => {
        var creds = await getSavedUser();
        if (!creds?.user?.id) return;
        var data = await authJsonGet(GuideTripList(1, 7, creds.user.id, false));
        dispatch({
            type: GUIDE_PRIVATE_TRIP_LIST,
            payload: data.code === 200 ? data.payload.product : [],
        });
    };
}
export async function submitOpenTrip(form: any) {
    try {
        let newForm = form;
        var creds = await getSavedUser();
        if (!creds?.user?.id) return false;
        newForm.user = creds.user.id;
        newForm.isOpenTrip = true;

        if (newForm.id) {
            if (newForm.country?.length == 0) {
                newForm.country = null;

            }
            // newForm.state = 'draft';
        }

        var addListing = newForm.id ? await authJsonEdit({ product: [newForm] }) : await authJsonPost({ product: [newForm] });

        if (addListing.code === 200) {
            const checkMy = await authPostEmpty('auth/check-my-product');

            if (!newForm?.id) {
                let dataSend = {
                  "to":"me",
                  "product":checkMy.payload.data.productId,
                  "template":"listing_under_review"
                };
                const sendEmail = await authJsonPost(dataSend, 'auth/send-email-other');
                const sendEmailAdmin = await authJsonPost(dataSend, 'auth/send-email-admin');

            }
        }
        return addListing.code === 200;
    } catch (e) {
        return false;
    }
}


export async function submitPrivateTrip(form: any) {
    try {
        let newForm = form;
        var creds = await getSavedUser();
        if (!creds?.user?.id) return false;
        newForm.user = creds.user.id;
        newForm.isOpenTrip = false;
        newForm.minGuest = 0;
        // if (newForm.id) {
        //     newForm.state = 'draft';
        // }
        var addListing = newForm.id ? await authJsonEdit({ product: [newForm] }) : await authJsonPost({ product: [newForm] });
        if (addListing.code === 200) {
            const checkMy = await authPostEmpty('auth/check-my-product');
            if (checkMy.code === 200) {
                const topic = `open_trip_${checkMy.payload.data.productId}`;

                if (!newForm?.id) {
                    let dataSend = {
                      "to":"me",
                      "product":checkMy.payload.data.productId,
                      "template":"listing_under_review"
                    };
                    const sendEmail = await authJsonPost(dataSend, 'auth/send-email-other');
                    const sendEmailAdmin = await authJsonPost(dataSend, 'auth/send-email-admin');
                }
            }
        }
        return addListing.code === 200;
    } catch (e) {
        return false;
    }
}

export async function updateStateTrip(form: any) {
    try {
        let newForm = form;
        var creds = await getSavedUser();
        if (!creds?.user?.id) return false;
        newForm.user = creds.user.id;
        var update = await authJsonEdit({ product: [newForm] });

        return update;
    } catch (error) {
        return false;
    }
}



export function updateFormTrip(param: string, value: any) {
    newProduct[param] = value;
    return async (dispatch: DispatchGeneral) => {
        dispatch({
            type: PARTNER_OPEN_TRIP_ADD,
            payload: newProduct,
        });
    };
}
export function resetForm() {
    return async (dispatch: DispatchGeneral) => {
        newProduct = {};
        dispatch({
            type: PARTNER_OPEN_TRIP_ADD,
            payload: {
                resetForm: true
            },
        });
    };
}

export function updateFormTripMass(params: any) {
    Object.keys(params).map((k: any, i: any) => {
        newProduct[k] = params[k];
    });

    return async (dispatch: DispatchGeneral) => {
        dispatch({
            type: PARTNER_OPEN_TRIP_ADD,
            payload: newProduct,
        });
    };
}

export function getServices(keyword: any) {
    return async (dispatch: DispatchGeneral) => {
        let data

        if (keyword) {
            data = await get('api/service?q=' + keyword);
        } else {
            data = await get('api/service');
        }

        dispatch({
            type: GET_SERVICES,
            payload: data.code !== 200 ? [] : data.payload.data,
        });
    };
}

export function dataDeleteService(params: any, data: any = []) {
    return async (dispatch: DispatchGeneral) => {
        let dataDelete = params === null ? [] : [params];
        if (data.length > 0) {
            data.push(params)
        }
        dispatch({
            type: DELETE_SERVICE,
            payload: data.length > 0 ? data : dataDelete
        })
    }
}